import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { TrendingUp } from "lucide-react";

const SERIES = [
  { key: "acts", label: "Activations", color: "#0d9488" },
  { key: "upgrades", label: "Upgrades", color: "#1e3a5f" },
  { key: "edge_apps", label: "Edge Apps", color: "#f59e0b" },
  { key: "topups", label: "Top-Ups", color: "#6366f1" },
];

export const SalesTrendChart = ({ trend, title = "Daily Trend" }) => {
  const [metric, setMetric] = useState("acts");
  const s = SERIES.find((x) => x.key === metric);
  const data = trend.map((t) => ({ ...t, label: t.date.slice(5).replace("-", "/") }));
  return (
    <Card className="border-slate-200" data-testid="vz-trend-card">
      <CardHeader className="pb-2 flex-row items-center justify-between flex-wrap gap-2">
        <CardTitle className="text-base flex items-center gap-2"><TrendingUp className="w-4 h-4 text-teal" /> {title}</CardTitle>
        <div className="flex gap-1 flex-wrap">
          {SERIES.map((x) => (
            <Button key={x.key} size="sm" variant={metric === x.key ? "default" : "outline"} className="h-7 text-xs"
              onClick={() => setMetric(x.key)} data-testid={`vz-trend-${x.key}`}>{x.label}</Button>
          ))}
        </div>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? <p className="text-sm text-slate-500 py-10 text-center">No daily data yet.</p> : (
          <div style={{ width: "100%", height: 240 }}>
            <ResponsiveContainer>
              <BarChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
                <XAxis dataKey="label" fontSize={11} tick={{ fill: "#475569" }} />
                <YAxis allowDecimals={false} fontSize={11} tick={{ fill: "#475569" }} />
                <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
                <Bar dataKey={metric} name={s.label} fill={s.color} radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
